import api from "../ApiConfig";
import { Apis } from "../../config";
import { NotificationManager } from "react-notifications";
import unauthService from "../unauth";

const CreateClient = async (data) => {
  try {
    const result = await api.post(Apis.GetAllClientList + "/create", data, {
      // withCredentials: true,
      headers: { "Content-Type": "application/json" },
    });
    const parsedData = JSON.parse(result.data);
    const parsedResult = JSON.parse(parsedData.body);
    if (!parsedResult.success) {
      NotificationManager.error(parsedResult.message);
      return null;
    }
    if (parsedResult.success) {
      NotificationManager.success(parsedResult.message);
    }
    return parsedResult;
  } catch (error) {
    if (error.status == 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};

const GetClientList = async (data) => {
  try {
    const result = await api.get(Apis.GetAllClientList, data, {
      // withCredentials: true,
      headers: { "Content-Type": "application/json" },
    });
    let parsedData = JSON.parse(result.data);
    const response = JSON.parse(parsedData.body);
    console.log(response);

    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return response?.additionalData || [];
  } catch (error) {
    if (error.status == 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    // NotificationManager.error('An error occurred while logging in.');
    return null;
  }
};

const DeleteClient = async (id) => {
  try {
    const result = await api.delete(
      Apis.GetAllClientList + "/delete?id=" + id,
      {
        // withCredentials: true,
        headers: { "Content-Type": "application/json" },
      }
    );
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    NotificationManager.success("Article Deleted successfully", "Success");

    return result.data;
  } catch (error) {
    if (error.status == 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    // NotificationManager.error('An error occurred while logging in.');
    return null;
  }
};

const GetClientListPage = async (filterVal) => {
  try {
    const result = await api.get(
      `${Apis.GetAllClientList}/filter/?searchText=${filterVal.searchText}&pageNumber=${filterVal.pageNumber}&pageSize=${filterVal.pageSize}`,
      {
        // withCredentials: true,
        headers: { "Content-Type": "application/json" },
      }
    );
    let parsedData = JSON.parse(result.data);
    let response = JSON.parse(parsedData.body);
    console.log("clientlint", response);

    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return response.additionalData;
  } catch (error) {
    if (error.status == 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    // NotificationManager.error('An error occurred while logging in.');
    return null;
  }
};

const UpdateClient = async (data) => {
  try {
    const result = await api.put(Apis.GetAllClientList, data, {
      headers: { "Content-Type": "application/json" },
    });
    const parsedData = JSON.parse(result.data);
    const parsedResult = JSON.parse(parsedData.body);
    if (!parsedResult.success) {
      NotificationManager.error(parsedResult.message);
      return null;
    }
    NotificationManager.success("Client updated successfully");
    return parsedResult;
  } catch (error) {
    if (error.status == 401) {
      unauthService();
    }
    console.error("Error updating client:", error);
    return null;
  }
};

export default {
  CreateClient,
  GetClientList,
  GetClientListPage,
  DeleteClient,
  UpdateClient,
};
